export const getGenderAbbreviation = (gender: string) =>
  gender === 'Male' ? 'M' : gender === 'Female' ? 'F' : 'Unk'
